// extracted by mini-css-extract-plugin
export default {"addBlogContainer":"style_addBlogContainer__WO9gE"};